import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"

import CreateSbpOutcomeTransferRequest from "../../pages/SbpOutcomeTransferRequest/Create"
import { RootState } from "../../store/store"
import { m2mPullSteps } from "../../store/slices/routingSlice/flowsSteps"
import BankSelection from "../../pages/BankSelection"
import { IBankMeta, BankRole, BankScenario } from "../../api/interface"
import { setSelectedBank } from "../../store/slices/m2mSlice"
import { setNextStep } from "../../store/slices/routingSlice/routingSlice"
import PaymentToolsM2M from "../../pages/PaymentToolsM2M"
import { useGetSbpOutcomeTransferRequestStatus } from "../../api/hooks/useGetSbpOutcomeTtransferRequestStatus"
import SbpOutcomeTransferRequestStatus from "../../pages/SbpOutcomeTransferRequest/Status"
import { getStatusDetails } from "../../utils/transferRequest"

// создание запроса на перевод из другого банка
const M2MPullFlow = () => {
  const dispatch = useDispatch()
  const [enablePolling, setEnablePolling] = useState(false)
  const [outcomeTransferRequestId, setOutcomeTransferRequestId] = useState("")
  const transferRequestStep = useSelector((state: RootState) => state.routing.routes.refillM2M.currentStep)

  const { data: getOutcomeTransferRequestResponse } = useGetSbpOutcomeTransferRequestStatus(outcomeTransferRequestId, enablePolling)

  useEffect(() => {
    if (outcomeTransferRequestId) setEnablePolling(true)
    if (getOutcomeTransferRequestResponse) {
      const statusDetails = getStatusDetails(getOutcomeTransferRequestResponse?.status!)
      if (statusDetails.isFinal)
        setEnablePolling(false)
    }
  }, [outcomeTransferRequestId, getOutcomeTransferRequestResponse?.status])

  const handleBankClick = (bank: IBankMeta) => {
    dispatch(setSelectedBank(bank))
    dispatch(setNextStep())
  }

  switch (transferRequestStep) {
    case m2mPullSteps.refill.name: {
      return <CreateSbpOutcomeTransferRequest setOutcomeTransferRequestId={setOutcomeTransferRequestId} />
    }
    case m2mPullSteps.paymentToolsM2M.name: {
      return <PaymentToolsM2M />
    }
    case m2mPullSteps.linkingBankSelection.name: {
      return (
        <BankSelection
          handleBankClick={handleBankClick}
          role={BankRole.SENDER}
          scenario={BankScenario.M2M_PULL}
        />
      )
    }
    case m2mPullSteps.refillRequestDetails.name: {
      return getOutcomeTransferRequestResponse?.status ? (
        <SbpOutcomeTransferRequestStatus outcomeTransferRequestId={getOutcomeTransferRequestResponse?.outcomeTransferRequestId} />
      ) : null
    }
    default: {
      return <CreateSbpOutcomeTransferRequest setOutcomeTransferRequestId={setOutcomeTransferRequestId} />
    }
  }
}

export default M2MPullFlow
